module.exports = __webpack_public_path__ + "static/media/maca.b5010c1d.png";